import { motion, useAnimation, useInView } from "framer-motion";
import { useEffect, useRef } from "react";

/**
 * Reveal: anima su contenido cuando entra al viewport.
 * Props: className, delay, y children.
 */
export default function Reveal({ className="", delay=0, children }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px" });
  const controls = useAnimation();

  useEffect(() => {
    if (inView) controls.start("visible");
  }, [inView, controls]);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={{
        hidden: { opacity: 0, y: 24 },
        visible: { opacity: 1, y: 0, transition: { duration: .6, ease: "easeOut", delay } },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
